export default function isEditing(campaignType, status) {
    return (
      _.includes(['sms_conversations', 'sms_survey', 'phone'], campaignType) &&
      _.includes(['launching', 'live', 'sent', 'paused'], status)
    )
  }
